<script setup lang="ts">
import {
  TransitionRoot,
  TransitionChild,
  Dialog as HuiDialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
import { X } from "lucide-vue-next";

defineProps<{ open: boolean; title: string }>();
const emit = defineEmits<{ (e: "close"): void }>();
</script>

<template>
  <TransitionRoot appear :show="open" as="template">
    <HuiDialog as="div" class="relative z-50" @close="emit('close')">
      <TransitionChild
        as="template"
        enter="duration-150 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-100 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/40" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4">
          <TransitionChild
            as="template"
            enter="duration-150 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-md rounded border border-border bg-bg p-5 text-fg shadow-lg dark:border-border-dark dark:bg-surface-dark dark:text-fg-dark"
            >
              <div class="flex items-start justify-between gap-4">
                <DialogTitle class="text-base font-medium">{{ title }}</DialogTitle>
                <button
                  type="button"
                  class="rounded p-1 text-fg-muted hover:bg-surface dark:hover:bg-bg-dark"
                  @click="emit('close')"
                  aria-label="Close dialog"
                >
                  <X :size="16" />
                </button>
              </div>
              <div class="mt-3">
                <slot />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </HuiDialog>
  </TransitionRoot>
</template>
